export { default as DashboardPage } from './management'

